import React from "react";
import { Slider, Button, Brands } from "../components";
import Arrow from "../img/arrow-circle-down.svg";
import {Link} from "react-router-dom"

const Home = () => {
  return (
    <>
      <Slider />
      <section className="bg-black px-8 py-10 -mt-[1px] lg:px-16">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
        <div className="grid  grid-cols-1 lg:grid-cols-2 py-8">
          <div className="text-white text-left">
            <div className="headings text-[36px] font-bold leading-[39px] md:text-[50px] md:leading-[60px] lg:text-[96px] lg:leading-[99px]">
              <h1>HI THERE!</h1>
              <h1>
                I'M <span className="text-primary">TEMIDAYO</span>
              </h1>
            </div>
            <p className="text-[22px] leading-[36px] font-medium mb-4">
              I create Next-Level Visual Content. My Design Forte are Brand
              Identity and Advertising Design. I’m Passionate about Growth and
              I’VE offered Visual Solutions to Brands for Half a Decade.
            </p>
          </div>

          <div className="justify-start md:ml-auto flex md:self-end">
            <Link to="/about">
            <Button text="Know More" src={Arrow} />
            </Link>
          
          </div>
        </div>
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </section>
      
  
      <Brands/>
 
    

      <section className="bg-black px-8 py-10 -mt-[1px] lg:px-16">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
        <div className="grid  grid-cols-1 lg:grid-cols-2 py-8">
          <div className="text-white">
            <div className="headings text-[32px] md:text-[64px] md:leading-[96px] text-left pb-4 md:pb-0">
              <h1> <span className="italic font-bold">DIVE &nbsp;</span>INTO MY</h1>
              <h1>
                WORLD OF <span className="italic font-bold">MAGIC</span>
              </h1>
            </div>
           
          </div>
       
          <div className="justify-start md:ml-auto flex md:self-end">
          <Link to="/showcase">
            <Button text="Go to Showcase" to="/showcase" src={Arrow} />
            </Link>
          </div>
        
         
        </div>
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </section>

    </>
  );
};

export default Home;
